import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-download/download/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const remove = (id) => {
  return request({
    url: '/api/blade-download/download/remove',
    method: 'post',
    params: {
      id,
    }
  })
}
